module.exports = new __parcel__URL__("recruitment_en.a5221b28.webp").toString();